/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { environment } from '../../../../environments/environment';

export const xdefaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        subtitle: 'Acompanhe em tempo real sua operação',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'dashboards.analytics',
                title: 'Analytics',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/dashboards/analytics',
            },
            {
                id: 'dashboards.categories',
                title: 'Categorias',
                type: 'basic',
                icon: 'heroicons_outline:tag',
                link: '/users/categories',
            },
            {
                id: 'dashboards.products',
                title: 'Anúncios',
                type: 'basic',
                icon: 'heroicons_outline:shopping-bag',
                link: '/users/products',
            },
            {
                id: 'dashboards.push-notifications',
                title: 'Push Notifications',
                type: 'basic',
                icon: 'heroicons_outline:bell',
                link: '/push-notifications',
            },
            {
                id: 'dashboards.campaign-stories',
                title: 'Stories Grátis',
                type: 'basic',
                icon: 'heroicons_outline:gift',
                link: '/campaign-stories',
            },
        ],
    },
    {
        id: 'api',
        title: 'API',
        subtitle: 'Conecte o SmartNotas na sua aplicação',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'tokens',
                title: 'Aplicações',
                type: 'basic',
                icon: 'heroicons_outline:key',
                link: '/token',
            },
            {
                id: 'docs',
                title: 'Documentação',
                type: 'basic',
                icon: 'heroicons_outline:book-open',
                link: 'https://smart-notas.readme.io/',
                externalLink: true,
                target: '_blank',
            },
            {
                id: 'docs',
                title: 'Ambiente de Produção',
                type: 'basic',
                icon: 'heroicons_outline:arrow-right',
                link: 'https://app3.smart-notas.com',
                externalLink: true,
                hidden: (item) => {
                    return environment.name != 'sandbox';
                },
            },
            {
                id: 'docs',
                title: 'Ambiente Sandbox',
                type: 'basic',
                icon: 'heroicons_outline:arrow-right',
                externalLink: true,
                hidden: (item) => {
                    return environment.name != 'production';
                },
                link:
                    'https://app.sandbox.smart-notas.com/check-t?t=' +
                    localStorage.getItem('accessToken'),
                // function: function (item) {
                //     item.link = 'https://app.sandbox.smart-notas.com/check-t?t='+localStorage.getItem("accessToken")
                // }
            },
        ],
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const emptyNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
